import {
  Swiper,
  Navigation,
  Pagination,
} from 'swiper';

import type { SwiperOptions } from 'swiper';

Swiper.use([
  Navigation,
  Pagination,
]);

const blogSliders = (slider: HTMLElement) => {
  // Default options for each swiper instance
  const defaultOptions: SwiperOptions = {
    loop: false,
    slidesPerView: 2,
    breakpoints: {
      991: {
        slidesPerView: 1,
      },
      1200: {
        slidesPerView: 2,
      },
    },
    spaceBetween: 32,
    height: 240,
    slideActiveClass: 'slider__slide--active',

    navigation: {
      nextEl: '.blogslider-singleproduct__next',
      prevEl: '.blogslider-singleproduct__prev',
    },

    pagination: {
      el: slider.querySelector('.swiper-pagination') as HTMLElement,
      modifierClass: 'slider__pagination--',
      bulletClass: 'slider__bullet',
      bulletActiveClass: 'slider__bullet--active',
      clickable: true,
      clickableClass: 'slider__pagination--clickable',
    },
  };

  // If slider has custom options combine them and create
  // Swiper instance, otherwise create Swiper instance with
  // default options (custom overwrites default)
  const extendedOptions: SwiperOptions = JSON.parse(decodeURIComponent(slider.getAttribute('data-swiper')));

  const headerTitles: NodeListOf<HTMLElement> = document.querySelectorAll('.set-swiper');
  headerTitles.forEach((title: HTMLElement) => {
    title.addEventListener('click', () => {
      setTimeout(() => {
        window.dispatchEvent(new Event('resize'));
      }, 10);
    });
  });
  return new Swiper(slider, { ...defaultOptions, ...extendedOptions });
};

export default blogSliders;
